import {Icon, SwitchComponent} from "../../../components/table";
import {Link} from "react-router-dom";
import React from "react";
import styled from "styled-components";
import {deviceTypeInfo, productTypeInfo} from "./common";
import {confirmAllType} from "./medialistdetail";
import {atom} from "jotai";

export const mediaSearchResult = atom([]);

const EXAMINATION_TAG_COLORS = {
  CONFIRMING: {bg: 'var(--color-primary-soft)', color: 'var(--color-primary-strong)'},
  APPROVED: {bg: '#e8f7ef', color: '#178653'},
  REJECTED: {bg: '#fef2f2', color: '#b91c1c'},
};

function ExaminationTag({value}) {
  const label = confirmAllType.find(item => item.value === value)?.label || value || '-';
  const {bg, color} = EXAMINATION_TAG_COLORS[value] || {bg: '#f1f3f5', color: '#77818c'};
  return <ExaminationTagBox style={{background: bg, color}}>{label}</ExaminationTagBox>;
}

const ExaminationTagBox = styled.span`
  display: inline-flex;
  min-width: 54px;
  height: 23px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  font-size: var(--font-size-12);
  font-weight: 750;
`;

export const columnData = (onPublishChange) => [
  {
    name: 'publishYn',
    header: '게재 상태',
    width: 90,
    showColumnMenuTool: false, // 설정메뉴표시
    sortable: false,
    render: ({value, cellProps}) => {
      const valueYn = (value === 'Y');
      const disabled = cellProps.data.examinationStatus !== "APPROVED"
      return (
        <SwitchComponent value={valueYn} cellProps={cellProps} disabled={disabled} eventClick={nextValue=>onPublishChange(cellProps.data.inventoryId, nextValue)}/>
      );
    }
  },
  //{
  //  name: 'siteName',
  //  header: '매체명',
  //  defaultWidth: 200, //가변 사이즈
  //  textAlign: 'center',
  //  showColumnMenuTool: false,
  //},
  //{
  //  name: 'username',
  //  header: '아이디',
  //  textAlign: 'center',
  //  showColumnMenuTool: false,
  //},
  // {
  //   name: 'createdAt',
  //   header: '생성 날짜',
  //   textAlign: 'center',
  //   showColumnMenuTool: false,
  // },
  {
    name: 'inventoryName',
    header: '지면명',
    textAlign: 'center',
    defaultWidth: 250, //가변 사이즈
    resizeable: true, //리사이징
    cellProps: {
      style: {
        justifyContent: 'center'
      }
    },
    render: ({value, cellProps}) => {
      return(
        <Link className={'ellipsis'} to={"/board/mediaListDetail"} state={cellProps.data.inventoryId}>{value}</Link>
      )
    }
  },
  {
    name: 'productType',
    header: '광고 상품',
    textAlign: 'center',
    width: 100,
    resizeable: false,
    showColumnMenuTool: false,
    render: ({value}) => {
      return productTypeInfo.find(type => type.value === value)?.label;
    }
  },
  {
    name: 'deviceType',
    header: '디바이스',
    textAlign: 'center',
    defaultWidth: 100,
    showColumnMenuTool: false,
    render: ({value}) => {
      return deviceTypeInfo.find(type => type.value === value).label;
    }
  },
  //{
  //  name: 'bannerSize',
  //  header: '지면 사이즈',
  //  textAlign: 'center',
  //  showColumnMenuTool: false,
  //  render: ({value}) => {
  //    return value!= null ? value?.replace('IMG','') : '-' ;
  //  }
  //},
  {
    name: 'feeCalculation',
    header: '정산 방식',
    textAlign: 'center',
    showColumnMenuTool: false,
    render: ( { value } ) => {
      return value != null && (value.calculationType + "("+value.calculationValue+")")
    }
  },
  {
    name: 'script',
    header: '스크립트',
    textAlign: 'center',
    defaultWidth: 100,
    render: ({value, cellProps}) => {
      return <Icon icon={'script'} value={value} cellProps={cellProps}/>
    }
  },
  {
    name: 'examinationStatus',
    header: '심사상태',
    textAlign: 'center',
    showColumnMenuTool: false,
    render: ({ value }) => {
      return <ExaminationTag value={value}/>
    }
  }
]
